import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useState } from 'react';
import { Button } from '../../ui/button';
import { Spinner } from '../Spinner';
export const LoadingButton = forwardRef(({ icon, onClick, disabled, children, ...props }, forwardedRef) => {
    const [loading, setLoading] = useState(false);
    return (_jsxs(Button, { ...props, ref: forwardedRef, disabled: disabled || loading, onClick: async (e) => {
            try {
                setLoading(true);
                await onClick?.(e);
            }
            finally {
                setLoading(false);
            }
        }, children: [loading ? _jsx(Spinner, {}) : icon, children] }));
});
